import * as React from 'react';
const SvgTransferCandidate = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_447_24013)">
      <path
        d="M13.8733 10.0945C13.1747 11.9074 11.6487 13.3729 9.62833 13.9142C6.27168 14.8137 2.82142 12.8217 1.92201 9.465L1.82621 9.10749M2.12626 5.57842C2.82499 3.76547 4.35093 2.30003 6.37126 1.75868C9.72794 0.859259 13.1782 2.85126 14.0776 6.20792L14.1734 6.56544M0.755038 10.5441L1.80192 8.73081L3.61517 9.77769M12.3844 5.89523L14.1977 6.94212L15.2446 5.12886"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity={0.12}
        d="M7.99902 5.32666C8.54279 5.32666 8.98416 5.76732 8.98438 6.31104C8.98438 6.85494 8.54293 7.29639 7.99902 7.29639C7.45531 7.29617 7.01465 6.8548 7.01465 6.31104C7.01487 5.76746 7.45544 5.32688 7.99902 5.32666Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.08}
      />
      <path
        d="M4.74316 10.9121C5.58836 10.0157 6.73586 9.46475 7.99978 9.46475C9.26371 9.46475 10.4112 10.0157 11.2564 10.9121M9.62809 6.38905C9.62809 7.28834 8.89908 8.01736 7.99978 8.01736C7.10049 8.01736 6.37147 7.28834 6.37147 6.38905C6.37147 5.48976 7.10049 4.76074 7.99978 4.76074C8.89908 4.76074 9.62809 5.48976 9.62809 6.38905Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_447_24013">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTransferCandidate;
